import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme';
import '../styles/components/topbar.css';

export default function Topbar({ onMenuToggle }) {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="topbar">
      <button className="hamburger" onClick={onMenuToggle} aria-label="Menu">
        &#9776;
      </button>
      <div className="topbar-actions">
        <button className="theme-toggle" onClick={() => navigate('/help')} aria-label="Help">
          <span>?</span>
        </button>
        <button className="theme-toggle" onClick={toggle}>
          <span>{theme === 'dark' ? '\u263E' : '\u2600'}</span>
          <span>{theme === 'dark' ? 'Dark' : 'Light'}</span>
        </button>
      </div>
    </div>
  );
}
